import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Hace scroll al tope (0,0) cada vez que cambia la ruta. Soluciona el caso en
 * que React Router preserva la posición del scroll del usuario al navegar
 * entre links del Navbar (Descubrir, Rutas, Huesos, etc.).
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    // `instant` para que sea inmediato; sin saltos visibles entre páginas.
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}
